import React from 'react';
import { Container, Row, Col, Nav, NavItem } from 'reactstrap';
import { Switch, Route, NavLink, } from 'react-router-dom';
import { connect } from 'react-redux';

import { WhitePanelLayout } from '@dom/components';

import GuideBannerForm from './GuideBannerForm';
import GuideBasicInformationForm from './GuideBasicInformationForm';
import GuideContactsForm from './GuideContactsForm';
import GuideProfessionalInformationForm from './GuideProfessionalInformationForm';
import GuideAvailabilityForm from './GuideAvailabilityForm';
import GuideUpcomingTreksForm from './GuideUpcomingTreksForm';

import './editProfile.scss';

function EditProfile({ match, userId }) {
  return (
    <div>
      <Container>
        <GuideBannerForm />
        <Row>
          <Col md="3" sm="12">
            <WhitePanelLayout>
              <Nav vertical>
                <NavItem>
                  <NavLink to={`${match.url}/basic`}>Basic Information</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={`${match.url}/contacts`}>Contact Information</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={`${match.url}/professional`}>Professional Information</NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink to={`${match.url}/availability`}>Availability</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={`${match.url}/upcoming-treks`}>Upcoming Treks</NavLink>
                </NavItem> */}
              </Nav>
            </WhitePanelLayout>
          </Col>
          <Col md="9" sm="12">
            <Switch>
              <Route path={`${match.path}/basic`} component={() => <GuideBasicInformationForm userId={userId} />} />
              <Route path={`${match.path}/contacts`} component={() => <GuideContactsForm userId={userId}/>} />
              <Route path={`${match.path}/professional`} component={() => <GuideProfessionalInformationForm userId={userId}/>} />
              <Route path={`${match.path}/availability`} component={GuideAvailabilityForm} />
              <Route path={`${match.path}/upcoming-treks`} component={GuideUpcomingTreksForm} />
            </Switch>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const mapStateToProps = ({ user }) => ({
  userId: user.data && user.data.id,
});

export default connect(mapStateToProps)(EditProfile);
